import { useField } from "formik";
import { useEffect } from "react";
import { Body1Strong } from "@fluentui/react-components";
import React from "react";
import { ICartItemFormValues } from "./Schema";

type AmountProps = {
  amount: number;
  currencyUnit: string;
};

export const Amount = ({ amount, currencyUnit }: AmountProps) => {
  return <Body1Strong data-testid="amount">{`${currencyUnit}${amount.toFixed(2)}`}</Body1Strong>;
};

type DisplayItemAmountProps = AmountProps & {
  amountWithOptions: number;
  setAmountWithOptions: (amountWithOptions: number) => void;
};

export const DisplayItemAmount = ({
  amount,
  amountWithOptions,
  currencyUnit,
  setAmountWithOptions,
}: DisplayItemAmountProps) => {
  const [optionGroups] = useField<ICartItemFormValues["optionGroups"]>({
    name: "optionGroups",
  });

  useEffect(() => {
    if (optionGroups.value && optionGroups.value.length > 0 && amount) {
      const currentAmount = optionGroups.value.reduce((acc, optionGroup) => {
        if (optionGroup.options) {
          optionGroup.options.forEach((option) => {
            if (option.isSelected) {
              acc += option.price?.amount || 0;
            }
          });
        }
        return acc;
      }, amount);
      if (currentAmount !== amountWithOptions) {
        setAmountWithOptions(currentAmount);
      }
    }
  }, [optionGroups]);

  return <Amount amount={amountWithOptions} currencyUnit={currencyUnit} />;
};
